import { WorkflowNode } from '@ply-io/ply-front-shared-utilities';

import { TEMP_NODE_ID_KEY_PREFIX } from '../workflow-node.const';

type TempWorkflowNode = Omit<WorkflowNode, 'id'> & { id: WorkflowNode['id'] | string };

export const isNodeTemp = (node?: Pick<WorkflowNode | TempWorkflowNode, 'id'>): node is TempWorkflowNode =>
	!!node && node.id.toString().includes(TEMP_NODE_ID_KEY_PREFIX);
